export default __webpack_public_path__ + "static/cocktail-party-0d99e4073bb3ce9efb985575a53dc5c9.jpg";